//@flow
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {MenuItem, makeStyles, Typography} from '@material-ui/core';
import CustomSelect from '../../../../../../../../elements/CustomSelect/CustomSelect';
import {TRIGGER_FIELDS} from '../../../const';
import {FILTER_TYPES} from '../../../../../utils/triggerConfig';
import {
  FILTER_SET_VALUE_OPTIONS,
  setFilterFieldUpdates,
} from '../../../../../utils/filterFields';
import {useCrmSegments} from '../../../../../../../crm-segment/utils';
import {getFormError} from '../../../../../utils/formErrors';
import {colors} from '../../../../../../../../assets/styles/colors';
import type {CrmSegmentFilter as CrmSegmentFilterValues} from '../../../../../../../../entities';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '.5rem',
  },
  label: {
    fontSize: '.875rem',
    fontWeight: 600,
  },
  fieldError: {
    fontSize: '.8125rem',
    color: colors.danger,
  },
}));

type Props = {
  filterType: typeof FILTER_TYPES.CRM_SEGMENT,
};

export default function CrmSegmentFilter({filterType}: Props) {
  const classes = useStyles();
  const {register, watch, setValue, getValues, errors} = useFormContext();
  const {segments, loading} = useCrmSegments({size: 100});

  const fieldPrefix = `${TRIGGER_FIELDS.filters}.${filterType}`;

  useEffect(() => {
    register(`${fieldPrefix}.segmentId`);
  }, [register, fieldPrefix]);

  const allFilters = watch(TRIGGER_FIELDS.filters) || {};
  const filter: CrmSegmentFilterValues = allFilters[filterType] || {
    segmentId: '',
  };
  const segmentError = getFormError(errors, `${fieldPrefix}.segmentId`);

  return (
    <div className={classes.root}>
      <Typography className={classes.label}>Segmento</Typography>
      <CustomSelect
        placeholder={loading ? 'Cargando segmentos...' : 'Seleccionar segmento'}
        value={filter.segmentId || ''}
        onChange={event => {
          setFilterFieldUpdates(
            getValues,
            setValue,
            filterType,
            {segmentId: event.target.value},
            FILTER_SET_VALUE_OPTIONS
          );
        }}
        error={!!segmentError}
      >
        {segments.map(segment => (
          <MenuItem key={segment.id} value={segment.id}>
            {segment.name}
          </MenuItem>
        ))}
      </CustomSelect>
      {segmentError && (
        <Typography className={classes.fieldError}>{segmentError}</Typography>
      )}
    </div>
  );
}
